import React from 'react';
import { useCommonTranslation } from '../../modules/i18n/hooks/useTranslation';

interface LazyLoadingSpinnerProps {
  message?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const LazyLoadingSpinner: React.FC<LazyLoadingSpinnerProps> = React.memo(({ message, className = '', size = 'md' }) => {
  const { t } = useCommonTranslation();
  const resolvedMessage = message ?? t('status.loading');
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <div className={`flex h-full items-center justify-center ${className}`}>
      <div className='text-center'>
        <div className={`mx-auto mb-3 animate-spin rounded-full border-b-2 border-blue-600 ${sizeClasses[size]}`}></div>
        <p className={`text-gray-600 dark:text-dark-text-secondary ${textSizeClasses[size]}`}>{resolvedMessage}</p>
      </div>
    </div>
  );
});

LazyLoadingSpinner.displayName = 'LazyLoadingSpinner';

export default LazyLoadingSpinner;
